import {useState} from "react";
import ReactApexChart from "react-apexcharts";
import {Dropdown} from "react-bootstrap";
import DropdownMenu from "react-bootstrap/esm/DropdownMenu";
import DropdownToggle from "react-bootstrap/esm/DropdownToggle";
import DateModal from "./dateModal";

const ReviewStats = ({
  stats,
  optionsList,
  dateLabel,
  setDateLabel,
  dispatch,
  filter,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const safeStats = Array.isArray(stats) ? stats : [];

  const totalReviews = safeStats.reduce((acc, el) => {
    const count = Number(el?.count);
    return acc + (Number.isFinite(count) ? count : 0);
  }, 0);

  const getPercentage = (rating) => {
    const count = Number(
      safeStats.find((el) => el?.rating === rating)?.count ?? 0,
    );
    if (Number.isFinite(count) && totalReviews > 0) {
      return {percentage: (count * 100) / totalReviews, count};
    }
    return {percentage: 0, count: 0};
  };
  const data = {
    series: [
      getPercentage(5),
      getPercentage(4),
      getPercentage(3),
      getPercentage(2),
      getPercentage(1),
    ],
    options: {
      chart: {
        type: "radialBar",
        height: 270,
        offsetY: 0,
        offsetX: 0,
        sparkline: {
          enabled: true,
        },
      },
      plotOptions: {
        radialBar: {
          size: undefined,
          inverseOrder: false,
          hollow: {
            margin: 0,
            size: "25%",
            background: "transparent",
          },

          track: {
            show: true,
            background: "#e1e5ff",
            strokeWidth: "12%",
            opacity: 1,
            margin: 10, // margin is in pixels
          },
        },
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              offsetY: 0,
              offsetX: 0,
            },
            legend: {
              position: "bottom",
              offsetX: 0,
              offsetY: 0,
            },
          },
        },
      ],
      fill: {
        opacity: 1,
      },
      stroke: {
        lineCap: "round",
      },
      colors: ["#FF6600", "#1A64B9", "#5B5B5B", "#19295C", "#F1F1F1"],

      labels: ["5/5", "4/5", "3/5", "2/5", "1/5"],
      values: [5, 4, 3, 2, 1],
    },
  };

  return (
    <div className="w-full col-span-2 lg:col-span-1 !rounded-xl p-6 bg-white flex flex-col gap-3 justify-start items-start">
      <DateModal
        dispatch={dispatch}
        open={openModal}
        setOpen={setOpenModal}
        type={"review"}
        initialDate={filter?.reviewDate}
      />
      <div className="w-full justify-between flex items-center">
        <span className="text-[#19295C] text-lg font-bold">Évaluations</span>
        <Dropdown>
          <DropdownToggle
            variant=""
            className=" flex gap-2 items-center !p-0 font-medium !text-xs "
          >
            <span className="mr-2">{dateLabel}</span>
          </DropdownToggle>
          <DropdownMenu>
            {optionsList?.map((op, index) => (
              <Dropdown.Item
                key={index}
                onClick={() => {
                  setDateLabel(op.label);
                  op.onClick("Nombre de reviews");
                }}
                className="!text-sm"
              >
                {op.label}
              </Dropdown.Item>
            ))}
            <Dropdown.Item
              onClick={() => {
                setOpenModal(true);
                setDateLabel("Choisir la date");
              }}
              className="!text-sm"
            >
              Choisir la date
            </Dropdown.Item>
          </DropdownMenu>
        </Dropdown>
      </div>

      <div className="w-full flex flex-col-reverse lg:flex-row items-center justify-between gap-2">
        <div className="flex !flex-row lg:!flex-col !flex-wrap lg:!flex-nowrap justify-start gap-2">
          {data?.options?.values?.map((el, index) => (
            <div className="flex items-center justify-start gap-2" key={index}>
              <div
                style={{
                  backgroundColor: data?.options?.colors[index],
                }}
                className={`w-5 aspect-square rounded-full  `}
              ></div>
              <div className="flex flex-col items-start justify-center text-[13px] font-medium text-[#19295C] ">
                {/* <span className="">{Number(el)}</span> */}
                <div className="flex items-center 2xl:gap-1 ">
                  {Array.from({length: 5}, (_, index) => (
                    <div
                      key={index}
                      className={`font-thin text-sm sm:text-xl text-[#FFC107] `}
                    >
                      {" "}
                      {index < Math.round(el) ? "★" : "☆"}
                    </div>
                  ))}
                </div>
                <span className="text-[#7E7E7E]">
                  {data?.series[index].percentage}% ({data?.series[index].count}{" "}
                  avis )
                </span>
              </div>
            </div>
          ))}
        </div>
        <div>
          <ReactApexChart
            options={data.options}
            series={data.series.map((el) =>
              Number.isFinite(Number(el?.percentage))
                ? Number(el.percentage)
                : 0,
            )}
            type="radialBar"
            height="270px"
          />
        </div>
      </div>
    </div>
  );
};

export default ReviewStats;
